/**
 * Ported from plm/portal/ui/lib/quickTests/web/legacy/ISPNameSelector.js
 * No jQuery usage in original; converted CommonJS module.exports to ESM default export.
 */

function ISPNameSelector() {
    const dictionary = {
        Comcast: 'Cc',
        'AT&T': 'AT&T',
        'Time Warner Cable': 'Twc',
        'tw telecom holdings, inc.': 'Twc',
        'Century Link': 'Cent',
        Charter: 'Char',
        Verizon: 'Vz',
        Cox: 'Cox',
        Optimum: 'Opti',
        'Amazon.com, Inc.': 'Ama',
        'Amazon Technologies': 'Ama',
        'Facebook, Inc.': 'Fb',
        Google: 'Goog',
        'Level 3': 'L3',
        'XO Communications': 'Xo',
        Ebay: 'Ebay',
        Yahoo: 'Yh',
        Salesforce: 'Sf',
        Equinix: 'Eq',
        Tektronix: 'Tek',
        'NTT America, Inc.': 'NTT',
        'Unknown Organization': '?',
    };

    this.getName = function getName(name) {
        let n = dictionary[name];
        if (!n) n = name.charAt(0).toUpperCase() + name.substring(1, 3).toLowerCase();
        return n;
    };
}

export default ISPNameSelector;
